var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResults = function SvgResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      version: 1
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0c16.6 0 30 13.4 30 30 0 16.6-13.4 30-30 30 -16.6 0-30-13.4-30-30 0-16.6 13.4-30 30-30Zm9 39c0 2.5 2 4.5 4.5 4.5 2.5 0 4.5-2 4.5-4.5l0-6c0-2.5-2-4.5-4.5-4.5 -2.5 0-4.5 2-4.5 4.5l0 6Zm-22.5 4.5c-2.5 0-4.5-2-4.5-4.5l0-12c0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5l0 12c0 2.5-2 4.5-4.5 4.5Zm13.5 0c-2.5 0-4.5-2-4.5-4.5l0-21c0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5l0 21c0 2.5-2 4.5-4.5 4.5Z"
  })));
};
export default SvgResults;